<div class="row">
    <div class="col-md-3 pad-80 pad-right-30">
        <label class="fw-bold text-dark mb-3">UPLOAD OR ADD/UPDATE </label> : Store
        <div class="row mb-2">
            <div class="col-md-12 col-xl-8 col-lg-8 col-xxl-8">
                <app-master-file-upload #fileUpload (productfileChanged)="onFilesChanged($event)"
                    [allowedFileTypes]="allowedFileTypeExtensions"
                    [srcFileComponent]="srcFileComponent"></app-master-file-upload>
            </div>
            <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-4 align-self-center">
                <button type="button" class="btn btn-outline-dark me-2" title="Upload Store's"
                    [disabled]="!fileToUpload" (click)="storeBulkUpload()">
                    <i class="fa-solid fa-upload"></i>
                </button>

                <button type="button" class="btn btn-outline-dark" title="Download Sample Excel"
                    (click)="downloadSampleExcel()">
                    <i class="fa-solid fa-download"></i>
                </button>
            </div>
        </div>
        <div class="row text-center">
            <h6 class="orText" style="font-size: 15px;">OR</h6>
        </div>
        <form [formGroup]="storeForm" (ngSubmit)="onSubmit()">
            <div class="customBg">
                <div class="row mb-2">
                    <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label class="required">Customer</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">

                        <select class="form-select" formControlName="vendorID" aria-label="Default select example">
                            <option value="0">Select Customer</option>
                            <option *ngFor="let item of vendorList" [value]="item.vendorID" [disabled]="item.vendorName !== 'Walmart'">{{item.vendorName}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center pe-0">
                        <label class="required">Store Number</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="text" class="form-control" maxlength="200" id="storeNumber"
                            formControlName="storeNumber">
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label class="required">TDLINX</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="text" id="tdlinx" formControlName="tdlinx" maxlength="200" class="form-control">
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label class="required">Store Name</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="text" id="storeName" maxlength="500" formControlName="storeName"
                            class="form-control">
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label class="required">Street</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="text" id="street" formControlName="street" maxlength="500" class="form-control">
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label class="required">City</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="text" id="city" formControlName="city" maxlength="100" class="form-control">
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label class="required">State</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <!-- <input type="text" id="state" formControlName="state" 
                            class="form-control"> -->
                        <!-- <select  class="form-select border-0" aria-label="Default select example"
                            formControlName="state">
                            <option value="0">Select State</option>
                            <option *ngFor="let item of usaStates" 
                                [value]="item.stateCode">{{item.stateName}}                                                                                    
                            </option>
                        </select> -->

                        <p-dropdown [options]="usaStates" formControlName="stateCode" optionLabel="stateName"
                            class="custom-dropdown" optionValue="stateCode" placeholder="Select a State" [filter]="true"
                            [virtualScroll]="true" [virtualScrollItemSize]="34">
                        </p-dropdown>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label class="required">Zip Code</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="text" id="zip" formControlName="zip" maxlength="100" class="form-control">
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label>Phone</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="text" id="phone" formControlName="phone" maxlength="100" class="form-control">
                    </div>
                </div>

                <!-- <div class="row mb-2">
                    <div
                        class="col-md-4 col-xl-4 col-lg-4 col-xxl-5 align-self-center">
                        <label>Is Active</label>
                    </div>
                    <div class="col-md-8 col-xl-8 col-lg-8 col-xxl-7">
                        <input type="checkbox" class="checkbox" 
                            [checked]="true" formControlName="isActive">
                    </div>
                </div> -->
            </div>
            <div class="row mt-3">
                <div class="col-md-12 text-end">
                    <button type="button" class="btn progressBtn" role="button" (click)="resetStoreForm()">
                        <img src="assets/images/close_mark.svg" class="datePickerIcon" alt="">
                        CLEAR
                    </button>
                    &nbsp;
                    <button class="btn progressBtn float-end" role="button">
                        <img src="assets/images/plus_icon.svg" class="datePickerIcon" alt="">
                        {{buttonText}}
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="col-md-9 pad-80">
        <div class="row">
            <div class="col-md-6">
                <label class="fw-bold text-dark mb-0">EDIT
                    EXISTING</label> : Store &nbsp;&nbsp;
                <label class="fw-bold text-dark mb-0">STORE(S) COUNT</label> :
                {{ (isTextSearchFilterApplied || isFilterApplied) ? filteredStores.length : allStores.length }}
            </div>
            <div class="col-md-5 position-relative">
                <form [formGroup]="searchForm">
                    <input type="text" class="form-control" formControlName="searchControl"
                        placeholder="SEARCH BY STORE #, TDLINX, STORE NAME, CITY, STATE">
                    <img src="assets/images/magnifying-glass.png" placeholder="Type Project Title to Filter"
                        class="searchIcon" alt="">
                </form>
            </div>
            <div class="col-md-1 align-self-center text-center">
                <form [formGroup]="filterForm">
                    <div class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle urserName" href="#" role="button" data-bs-toggle="dropdown"
                            aria-expanded="true" style="cursor: pointer;">
                            <img src="assets/images/filter.png" class="me-0 w-20" alt="" title="Filter">
                        </a>
                        <ul class="dropdown-menu customMargindrp" data-popper-placement="bottom-end"
                            style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate3d(0.8px, 24.8px, 0px);">

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>Customer</label>
                                </div>
                                <div class="col-md-7">
                                    <select class="form-select border-0" aria-label="Default select example"
                                        formControlName="searchVendorID">
                                        <option value="0">Select Customer</option>
                                        <option *ngFor="let item of vendorList" [value]="item.vendorID" [disabled]="item.vendorName !== 'Walmart'">
                                            {{item.vendorName}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>STORE NUMBER</label>
                                </div>
                                <div class="col-md-7">
                                    <input type="text" id="searchStoreNumber" class="form-control" maxlength="200"
                                        formControlName="searchStoreNumber">
                                </div>
                            </div>

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>TDLINX</label>
                                </div>
                                <div class="col-md-7">
                                    <input type="text" id="searchTdlinx" class="form-control" maxlength="200"
                                        formControlName="searchTdlinx">
                                </div>
                            </div>

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>STORE NAME</label>
                                </div>
                                <div class="col-md-7">
                                    <input type="text" id="searchStoreName" class="form-control" maxlength="500"
                                        formControlName="searchStoreName">
                                </div>
                            </div>

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>CITY</label>
                                </div>
                                <div class="col-md-7">
                                    <input type="text" id="searchCity" class="form-control" maxlength="100"
                                        formControlName="searchCity">
                                </div>
                            </div>

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>STATE</label>
                                </div>
                                 <!-- <p-dropdown [options]="usaStates" optionLabel="stateName" class="custom-dropdown"
                                        optionValue="stateCode" formControlName="searchStateCode"
                                        placeholder="Select a State" [filter]="true" [virtualScroll]="true"
                                        [virtualScrollItemSize]="34">
                                    </p-dropdown> -->
                                <div class="col-md-7" (click)="$event.stopPropagation()">
                                    <p-multiSelect [options]="usaStates" formControlName="searchStateCode" 
                                            optionLabel="stateName" optionValue="stateCode"
                                        placeholder="Select State" (click)="stopPropagation($event)" class="multicategories">
                                    </p-multiSelect>
                                </div>
                            </div>

                            <div class="row mb-12px">
                                <div class="col-md-5">
                                    <label>Is Active</label>
                                </div>
                                <div class="col-md-7">
                                    <select class="form-select border-0" aria-label="Default select example"
                                        formControlName="searchIsActive">
                                        <option *ngFor="let item of isActiveOptions" [value]="item.value">
                                            {{item.label}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="offset-md-3 col-md-9">
                                    <button type="button" (click)="onApplyFilter();" class="btn progressBtn ps-2 w-100"
                                        style="cursor: pointer;">APPLY
                                        FILTER</button>
                                </div>
                            </div>


                        </ul>
                    </div>
                </form>
            </div>
        </div>
        <div class="row mt-2" *ngIf="appliedFilters && isFilterApplied">
            <div class="col-md-10">
                <label class="fw-bold text-dark mb-0">Applied Filters:</label>
                <ul class="list-inline mt-2">
                    <li class="list-inline-item" *ngIf="appliedFilters.vendorName">
                        <strong>Customer:</strong> {{ appliedFilters.vendorName }}
                    </li>
                    <li class="list-inline-item" *ngIf="appliedFilters.storeNumber">
                        <strong>Store Number:</strong> {{ appliedFilters.storeNumber }}
                    </li>
                    <li class="list-inline-item" *ngIf="appliedFilters.tdlinx">
                        <strong>TDLINX:</strong> {{ appliedFilters.tdlinx }}
                    </li>
                    <li class="list-inline-item" *ngIf="appliedFilters.storeName">
                        <strong>Store Name:</strong> {{ appliedFilters.storeName }}
                    </li>
                    <li class="list-inline-item" *ngIf="appliedFilters.city">
                        <strong>City:</strong> {{ appliedFilters.city }}
                    </li>
                <li class="list-inline-item" *ngIf="appliedFilters.state" [title]="appliedFilters.state">
                    <strong>State:</strong>
                    {{ getLimitedStates(appliedFilters.state, 3) }}
                </li>
                    <li class="list-inline-item" *ngIf="appliedFilters.isActive">
                        <strong>Is Active:</strong> {{ appliedFilters.isActive }}
                    </li>
                </ul>
            </div>
            <div class="col-md-2">
                <button type="button" (click)="clearFilters();" class="btn progressBtn ps-2 w-100"
                    style="cursor: pointer;">CLEAR
                    FILTER</button>
            </div>
        </div>

        <div class="table-responsive tableFixHead mt-3" (scroll)="onScroll()"
            [ngClass]="{ 'table-filter-applied': appliedFilters && isFilterApplied, 'table-filter-default': !(appliedFilters && isFilterApplied) }">
            <table class="table datatable border-x-0 mb-0">
                <thead>
                    <tr class="subheaderrr">
                        <th scope="col" class="text-start py-2" width="10%">Customer</th>
                        <th scope="col" class="text-start py-2" width="10%">Store #</th>
                        <th scope="col" class="text-start py-2">TDLINX</th>
                        <th scope="col" class="text-start py-2">Store Name</th>
                        <!-- <th scope="col" class="text-start py-2">Street</th>   -->
                        <th scope="col" class="text-start py-2">city</th>
                        <th scope="col" class="text-start py-2">state</th>
                        <!-- <th scope="col" class="text-start py-2" width="10%">zip</th>  
                            <th scope="col" class="text-start py-2">phone</th>   -->
                        <th scope="col" class="text-start py-2">
                            Is Active</th>
                        <th scope="col" class="text-start py-2 border-end-0" width="8%">
                            ACTION</th>
                        <!-- <th scope="col" class="text-start py-2">Parent ID</th> 
                        
                            <th scope="col" class="text-start py-2" width="7%">
                                Is Verified</th>
                            <th scope="col" class="text-start py-2 border-end-0" width="8%">
                                ACTION</th> -->

                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of filteredStores">
                        <td class="vertical-align-middle">
                            {{item.vendorName}}
                        </td>
                        <td class="vertical-align-middle">
                            {{item.storeNumber}}
                        </td>
                        <td class="vertical-align-middle">
                            {{item.tdlinx}}
                        </td>
                        <td class="vertical-align-middle">
                            {{item.storeName}}
                        </td>
                        <!-- <td class="vertical-align-middle">
                                {{item.street}}
                            </td> -->
                        <td class="vertical-align-middle">
                            {{item.city}}
                        </td>
                        <td class="vertical-align-middle">
                            {{item.state}}
                        </td>
                        <!-- <td class="vertical-align-middle">
                                {{item.zip}}
                            </td>
                            <td class="vertical-align-middle">
                                {{item.phone}}
                            </td> -->
                        <td>
                            <div class="activeDesablebtn alignitemss">
                                <div class="toggle-button-cover">
                                    <div class="button-cover">
                                        <div class="button b2" id="button-14">
                                            <input type="checkbox" class="checkbox" [checked]="item.isActive"
                                                (change)="enableOrDisableStore($event, item)">
                                            <div class="knobs">
                                                <span></span>
                                            </div>
                                            <div class="layer"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="vertical-align-middle text-center">
                            <img src="assets/images/pencilIocn.svg" (click)="editStore(item.storeID!);" title="Edit"
                                alt="" style="cursor: pointer;">
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="card" *ngIf="filteredStores.length === 0 ">
                <div class="card-body py-2 px-3">
                    <div class="emtyCard p-0">
                        <p class="mb-0">No Records Found
                        </p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>